import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import { BridgeComponent } from './bridge.component';
import { WebSocketProxy } from './../services/websocket.proxy';
import { Guid, JoinRoomAction, SignalServerErrorCodes } from './../../../../common/index';
import { WebSocketProxyEvents, UIEvents } from './../utilitites/application.constants';
import { MediaStreamHelper } from './../utilitites/media-stream.helper';
import { IM_MessageType } from './../interfaces/message';
import { UIEventEmitter } from '../utilitites/ui-events';
import { CommonUtils } from '../utilitites/common-utils';
import { AppConfig } from './../utilitites/app-config';

var Peer = require("simple-peer");

export var Root = function (_React$Component) {
  _inherits(Root, _React$Component);

  var _super = _createSuper(Root);

  function Root(state, props) {
    var _this;

    _classCallCheck(this, Root);

    _this = _super.call(this, state, props);

    _defineProperty(_assertThisInitialized(_this), "_unhandledSignals", []);

    _defineProperty(_assertThisInitialized(_this), "_connectionClient", void 0);

    _defineProperty(_assertThisInitialized(_this), "_globalWindowObject", void 0);

    _defineProperty(_assertThisInitialized(_this), "_localSelectedCamera", "user");

    _defineProperty(_assertThisInitialized(_this), "_loggerInstance", void 0);

    _this._loggerInstance = window['Logger'];
    _this._globalWindowObject = window;
    var userId = sessionStorage["userId"];

    if (!userId || userId.length === 0) {
      userId = Guid.NewGuid().substring(0, 6);
      sessionStorage["userId"] = userId;
    }

    var deviceConnectionId = sessionStorage["deviceConnectionId"] || "";
    _this.state = {
      isCallConnected: false,
      bridgeId: sessionStorage['bridgeId'] || "",
      displayName: sessionStorage['displayName'] || "",
      errorSecurityCode: '',
      isWaiting: false,
      userId: userId,
      deviceConnectionId: deviceConnectionId,
      isWebSocketConnected: false,
      localMediaStream: null,
      localOrigMediaStream: null,
      remoteMediaStream: null,
      peerConnectionObject: null,
      joinRoomErrorMessage: '',
      systemMessages: [],
      isOnMute: false,
      isVideoOff: false,
      previousMediaStreams: [],
      logOutPreviousConnection: false,
      isConnecting: false
    };
    _this._connectionClient = {
      isAnswerSent: false,
      isOfferSent: false,
      peerConnection: null,
      receivedAnswer: false
    };

    if (sessionStorage['displayName']) {
      var displayNameLabel = document.getElementById('displayNameLabel');

      if (displayNameLabel) {
        displayNameLabel.innerText = sessionStorage['displayName'];
      }
    }

    return _this;
  }

  _createClass(Root, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var self = this;

      this._loggerInstance.logTrace("componentWillMount event of rootcomponent invoked");

      var websocketProxyInstance = WebSocketProxy.GetInstance();
      websocketProxyInstance.SubscribeWebSocketEvents(WebSocketProxyEvents.OnLoginSuccess, this.onLoginSuccess.bind(this));
      websocketProxyInstance.SubscribeWebSocketEvents(WebSocketProxyEvents.OnWebSocketDisconnected, this.onSocketDisconnected.bind(this));
      websocketProxyInstance.SubscribeWebSocketEvents(WebSocketProxyEvents.OnJoinRoomSuccess, this.onJoinRoomComplete.bind(this));
      websocketProxyInstance.SubscribeWebSocketEvents(WebSocketProxyEvents.OnOfferFromPeer, this.handleOffer.bind(this));
      websocketProxyInstance.SubscribeWebSocketEvents(WebSocketProxyEvents.OnSignalFromPeer, this.handleSignal.bind(this));
      websocketProxyInstance.SubscribeWebSocketEvents(WebSocketProxyEvents.OnForcedLoggedOut, this.handleForcedLoggedOut.bind(this));

      this._globalWindowObject.addEventListener('onAppointmentWindowClose', this.onAppointmentWindowClose.bind(this));

      UIEventEmitter.getInstance().subscribe(UIEvents.OnCallEndClicked, this.onEndCallByCurrentUser.bind(this));
      UIEventEmitter.getInstance().subscribe(UIEvents.OnFlipCameraClicked, this.flipCamera.bind(this));
      UIEventEmitter.getInstance().subscribe(UIEvents.OnMuteAudioClicked, this.toggleAudioStatus.bind(this));
      UIEventEmitter.getInstance().subscribe(UIEvents.OnTurnOffVideoClicked, this.toggleMyVideoDisplay.bind(this));
      UIEventEmitter.getInstance().subscribe(UIEvents.OnJoinCallClicked, this.OnJoinButtonClicked.bind(this));
      this.initiateConnection();
    }
  }, {
    key: "initiateConnection",
    value: function initiateConnection() {
      var self = this;
      var websocketProxyInstance = WebSocketProxy.GetInstance();
      this.getMediaStream().then(function (mediaStream) {
        self.setState({
          isConnecting: true
        });
        websocketProxyInstance.Login(self.state.userId, self.state.deviceConnectionId);
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._loggerInstance.logTrace("componentWillUnmount event of rootcomponent invoked");

      var websocketProxyInstance = WebSocketProxy.GetInstance();
      websocketProxyInstance.UnsubscribeWebSocketEvents(WebSocketProxyEvents.OnLoginSuccess, this.onLoginSuccess.bind(this));
      websocketProxyInstance.UnsubscribeWebSocketEvents(WebSocketProxyEvents.OnWebSocketDisconnected, this.onSocketDisconnected.bind(this));
      websocketProxyInstance.UnsubscribeWebSocketEvents(WebSocketProxyEvents.OnJoinRoomSuccess, this.onJoinRoomComplete.bind(this));
      websocketProxyInstance.UnsubscribeWebSocketEvents(WebSocketProxyEvents.OnOfferFromPeer, this.handleOffer.bind(this));
      UIEventEmitter.getInstance().unsubscribe(UIEvents.OnJoinCallClicked, this.OnJoinButtonClicked.bind(this));
    }
  }, {
    key: "getMediaStream",
    value: function getMediaStream() {
      var _this2 = this;

      var self = this;
      var constraints = MediaStreamHelper.getConstraints(true, true, this._localSelectedCamera);

      this._loggerInstance.logTrace("Initiate Call with constraint" + JSON.stringify(constraints));

      return MediaStreamHelper.getLocalMediaStream(constraints).then(function (localStream) {
        var previousStreams = self.state.previousMediaStreams;
        var modifiedStreams = [].concat(_toConsumableArray(previousStreams), [localStream]);
        self.setState({
          localMediaStream: localStream,
          previousMediaStreams: modifiedStreams
        });
      })["catch"](function (error) {
        _this2._loggerInstance.logException(error);

        _this2._loggerInstance.logEvent("Failed to get media streams from this device");
      });
    }
  }, {
    key: "onLoginSuccess",
    value: function onLoginSuccess(deviceConnectionId) {
      sessionStorage["deviceConnectionId"] = deviceConnectionId;
      this.setState({
        isWebSocketConnected: true,
        deviceConnectionId: deviceConnectionId
      });

      this._loggerInstance.logTrace("Login Succeeded. Proceeding with JoinBridge");

      this.joinBridge();
    }
  }, {
    key: "onSocketDisconnected",
    value: function onSocketDisconnected() {
      this._loggerInstance.logException(new Error("Socket connection disconnected."));
    }
  }, {
    key: "onJoinRoomComplete",
    value: function onJoinRoomComplete(joinRoomResponse) {
      var action = joinRoomResponse.joinRoomAction;
      var bridgeComponent = this.refs.bridgeComponent;
      this.setState({
        isConnecting: false
      });

      if (action == JoinRoomAction.None) {
        this._loggerInstance.logTrace("JoinRoom Failed with Wait error code" + joinRoomResponse.errorCode);

        var errorCode = joinRoomResponse.errorCode;

        if (errorCode === SignalServerErrorCodes.INVALID_SECURITY_CODE) {
          this.setState({
            joinRoomErrorMessage: 'Invalid Security Code.'
          });
        } else if (errorCode === SignalServerErrorCodes.ERROR_WITH_API_CALL) {
          this.setState({
            joinRoomErrorMessage: 'Error occurred while joining the bridge. Please try again.'
          });
          alert('Failed to join the room because of some error. Please try again on a new browser tab. ');
        } else if (errorCode === SignalServerErrorCodes.JOIN_ROOM_USER_COUNT_THRESHOLD_REACHED) {
          this.setState({
            joinRoomErrorMessage: 'This bridge can only be used by 2 users (1 Patient and 1 doctor). Currently there are 2 active users already connected to this bridge.'
          });
          var result = window.confirm('It seems you have already joined this meeting on a different device or browser instance. Joining meeting on this instance will log you out from the old instance. Do you still want to continue? ');

          if (result) {
            console.log("Result : " + result);
            this.setState({
              logOutPreviousConnection: true
            });
            this.joinBridge();
          }
        }

        return;
      }

      var currentTime = new Date();
      var callStartedmessage = {
        message: "Call started at ".concat(currentTime.getHours(), ":").concat(currentTime.getMinutes(), " "),
        messageId: Guid.NewGuid(),
        postedOn: new Date(),
        messageType: IM_MessageType.CallStatusUpdateSystemMessage
      };
      bridgeComponent.addMessage(callStartedmessage);
      var welcomeMessage = {
        message: "Hi ".concat(this.state.displayName, ", thanks for joining the call"),
        messageType: IM_MessageType.UserStatusUpdateSystemMessage,
        messageId: Guid.NewGuid(),
        postedOn: new Date(),
        icon: this.getIconStyleForCurrentUser()
      };
      bridgeComponent.addMessage(welcomeMessage);

      if (action == JoinRoomAction.InitiateCall) {
        this._loggerInstance.logTrace("JoinRoom completed with InitiateCall signal.");

        this.initiateCall();
      } else if (action == JoinRoomAction.Wait) {
        this._loggerInstance.logTrace("JoinRoom completed with Wait signal.");

        this.setState({
          isWaiting: true
        });
        var waitingMessage = {
          message: "Waiting for ".concat(sessionStorage["partnerName"], " to join the call"),
          messageType: IM_MessageType.CallStatusUpdateSystemMessage,
          messageId: Guid.NewGuid(),
          postedOn: new Date()
        };
        bridgeComponent.addMessage(waitingMessage);
      }

      var errorMessage = document.getElementById('divcallendmessage');
      if (errorMessage) errorMessage.style.display = "none";
    }
  }, {
    key: "initiateCall",
    value: function initiateCall() {
      var self = this;
      var peerConnection;
      this._connectionClient = {
        isAnswerSent: false,
        isOfferSent: false,
        peerConnection: null,
        receivedAnswer: false
      };
      self.setState({
        isCallConnected: true,
        isWaiting: false,
        isOnMute: false
      });

      self._loggerInstance.logTrace("Initiate PeerConnection from initiateCall()");

      peerConnection = self.InitPeer(true, this.state.localMediaStream);
      peerConnection.on("signal", function (signalObject) {
        if (signalObject.type === "offer") {
          self._loggerInstance.logTrace("Offer from PeerConnection Object");

          if (!self._connectionClient.receivedAnswer) {
            WebSocketProxy.GetInstance().SendOffer(signalObject, self.state.bridgeId);
            self._connectionClient.isOfferSent = true;
          }
        } else {
          self._loggerInstance.logTrace("Signal from PeerConnection Object");

          WebSocketProxy.GetInstance().SendSignal(signalObject, self.state.bridgeId);
        }
      });
      self._connectionClient.peerConnection = peerConnection;
    }
  }, {
    key: "handleOffer",
    value: function handleOffer(offer) {
      var self = this;
      var peerConnection = self.InitPeer(false, this.state.localMediaStream);
      self.setState({
        isWaiting: false,
        isCallConnected: true
      });
      peerConnection.on('signal', function (answer) {
        self._loggerInstance.logTrace("Signal from PeerConnection");

        WebSocketProxy.GetInstance().SendSignal(answer, self.state.bridgeId);
        self._connectionClient.isAnswerSent = true;
      });
      peerConnection.signal(offer);
      self._connectionClient.peerConnection = peerConnection;
    }
  }, {
    key: "handleSignal",
    value: function handleSignal(signalData) {
      if (signalData && signalData.type && signalData.type === "CLOSE-CONNECTION") {
        console.log("Closing connection.");
        this.onPeerCallEnd();
        return;
      }

      if (signalData.type && signalData.type === "offer") {
        this._loggerInstance.logTrace("Handling offer from remote peer");

        this.handleOffer(signalData);
        return;
      }

      if (signalData.type && signalData.type === "answer") {
        this._loggerInstance.logTrace("Handling answer from remote peer");

        this._connectionClient.receivedAnswer = true;
      }

      var peer = this._connectionClient.peerConnection;

      if (peer && !peer.destroyed) {
        this._loggerInstance.logTrace("Handling signal from remote peer");

        peer.signal(signalData);
      } else {
        this._loggerInstance.logTrace("Storing signal in unhandledSignals list");

        this._unhandledSignals.push(signalData);
      }
    }
  }, {
    key: "handleForcedLoggedOut",
    value: function handleForcedLoggedOut() {
      this.setState({
        remoteMediaStream: null,
        isCallConnected: false,
        isWaiting: false
      });
      this.closeMediaStreams();
      this.postForcedLogoutMessage();
    }
  }, {
    key: "onPeerCallEnd",
    value: function onPeerCallEnd() {
      var bridgeComponent = this.refs.bridgeComponent;
      var callEndByPeer = {
        message: "".concat(sessionStorage["partnerName"], " left the call"),
        messageType: IM_MessageType.UserStatusUpdateSystemMessage,
        messageId: Guid.NewGuid(),
        postedOn: new Date(),
        icon: this.getIconStyleForPeerUser()
      };
      bridgeComponent.addMessage(callEndByPeer);
      this.setState({
        isWaiting: true,
        remoteMediaStream: null,
        isCallConnected: false
      });

      this._globalWindowObject.dispatchCustomEvent("onCallEnd", {
        detail: {
          source: 'peer'
        }
      });

      this._loggerInstance.logEvent("CallEnd from Peer");
    }
  }, {
    key: "InitPeer",
    value: function InitPeer() {
      var isInitiating = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var stream = arguments.length > 1 ? arguments[1] : undefined;
      var self = this;
      var serverConfig = AppConfig.TurnServerConfiguration;

      if (window.location.href.toString().toLowerCase().indexOf('connect.indiaopd.com')) {
        serverConfig = AppConfig.TurnServerStagingConfiguration;
      }

      var peer = new Peer({
        initiator: isInitiating,
        stream: stream,
        trickle: true,
        config: serverConfig
      });

      if (!isInitiating) {
        while (this._unhandledSignals.length > 0) {
          var signalData = this._unhandledSignals.pop();

          peer.signal(signalData);
        }
      }

      peer.on("stream", function (stream) {
        self._loggerInstance.logEvent("OnStream event of peer connection fired");

        self.onRemoteVideoStream(stream);
      });
      peer.on("error", function (err) {
        self._loggerInstance.logEvent("onError event of peer connection fired");

        self._loggerInstance.logException(err);

        console.error('error', err);

        if (err.code === 'ERR_CONNECTION_FAILURE') {
          alert("Failed to connect with the ".concat(sessionStorage["partnerType"], " because of patchy network. Please try calling again."));
          self.closeMediaStreams();
          self.setState({
            isConnecting: false,
            isCallConnected: false,
            isWaiting: true
          });
          self.onEndCallByCurrentUser();
        }
      });
      peer.on('close', function () {
        self._loggerInstance.logEvent("OnClose event of peer connection fired");
      });
      peer.on('data', this.onMessageFromPeer.bind(this));
      peer._debug = console.log;
      window["peerObject"] = peer;
      this.setState({
        peerConnectionObject: peer
      });
      return peer;
    }
  }, {
    key: "onMessageFromPeer",
    value: function onMessageFromPeer(data) {
      this._loggerInstance.logEvent("onData event of peer connection fired");

      var message = JSON.parse(data);

      if (CommonUtils.isString(message.postedOn)) {
        message.postedOn = new Date(message.postedOn);
      }

      var bridgeComponent = this.refs.bridgeComponent;
      bridgeComponent.addMessage(message);
    }
  }, {
    key: "onRemoteVideoStream",
    value: function onRemoteVideoStream(remoteMediaStream) {
      var self = this;
      console.log("OnVideoStream method invoked... ");
      self.setState({
        isCallConnected: false
      });
      setTimeout(function () {
        var bridgeComponent = self.refs.bridgeComponent;
        var callEndMessage = {
          message: "".concat(sessionStorage["partnerName"], " joined the call"),
          messageType: IM_MessageType.UserStatusUpdateSystemMessage,
          messageId: Guid.NewGuid(),
          postedOn: new Date(),
          icon: self.getIconStyleForPeerUser()
        };
        bridgeComponent.addMessage(callEndMessage);
        self.setState({
          remoteMediaStream: remoteMediaStream,
          isCallConnected: true,
          isWaiting: false
        });
      }, 100);
    }
  }, {
    key: "getIconStyleForCurrentUser",
    value: function getIconStyleForCurrentUser() {
      return sessionStorage["partnerType"] === 'Doctor' ? 'fa fa-user' : 'fa fa-user-md';
    }
  }, {
    key: "getIconStyleForPeerUser",
    value: function getIconStyleForPeerUser() {
      return sessionStorage["partnerType"] === 'Patient' ? 'fa fa-user' : 'fa fa-user-md';
    }
  }, {
    key: "joinBridge",
    value: function joinBridge() {
      var self = this;
      this.state.previousMediaStreams.forEach(function (mediaStream) {
        MediaStreamHelper.closeMediaStream(mediaStream);
      });
      MediaStreamHelper.closeMediaStream(this.state.localMediaStream);
      this.setState({
        localMediaStream: null,
        remoteMediaStream: null,
        isOnMute: false,
        isVideoOff: false
      });
      this.getMediaStream().then(function (mediaStream) {
        var websocketProxyInstance = WebSocketProxy.GetInstance();
        websocketProxyInstance.JoinRoom(self.state.bridgeId, self.state.userId, self.state.logOutPreviousConnection);
      });
    }
  }, {
    key: "OnJoinButtonClicked",
    value: function OnJoinButtonClicked() {
      var self = this;

      this._loggerInstance.logEvent("Join Bridge Clicked");

      this.initiateConnection();
    }
  }, {
    key: "onSendMessageToPeer",
    value: function onSendMessageToPeer(messageInstance) {
      var message = CommonUtils.cloneJsonObject(messageInstance);
      message.messageFrom = this.state.displayName;
      this.state.peerConnectionObject.send(JSON.stringify(message));
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var jquery = window['jQuery'];
      jquery("#divAuth").modal('show');
      console.log("Bridge Componant Render");
    }
  }, {
    key: "onAppointmentWindowClose",
    value: function onAppointmentWindowClose() {
      this.onEndCallByCurrentUser();
      this.closeMediaStreams();
    }
  }, {
    key: "onEndCallByCurrentUser",
    value: function onEndCallByCurrentUser() {
      this._loggerInstance.logEvent("Call End button clicked by current user");

      WebSocketProxy.GetInstance().LeaveRoomAndLogOut(this.state.bridgeId, this.state.userId, this.state.deviceConnectionId);
      this.setState({
        remoteMediaStream: null,
        isCallConnected: false,
        isWaiting: false
      });

      this._globalWindowObject.dispatchCustomEvent("onCallEnd", {
        detail: {
          source: 'current-user'
        }
      });

      this.postCallEndMessage();
      this.clearPeerConnection();
    }
  }, {
    key: "clearPeerConnection",
    value: function clearPeerConnection() {
      this._connectionClient.isAnswerSent = false;
      this._connectionClient.isOfferSent = false;
      this._connectionClient.receivedAnswer = false;

      if (this._connectionClient.peerConnection) {
        this._connectionClient.peerConnection.destroy();

        this._connectionClient.peerConnection = null;
      }
    }
  }, {
    key: "closeMediaStreams",
    value: function closeMediaStreams() {
      MediaStreamHelper.closeMediaStream(this.state.localMediaStream);
      this.state.previousMediaStreams.forEach(function (mediaStream) {
        MediaStreamHelper.closeMediaStream(mediaStream);
      });
      this.setState({
        localMediaStream: null,
        localOrigMediaStream: null
      });
    }
  }, {
    key: "postCallEndMessage",
    value: function postCallEndMessage() {
      var bridgeComponent = this.refs.bridgeComponent;
      var currentTime = new Date();
      var callEndMessage = {
        message: "Call ended at ".concat(currentTime.getHours(), ":").concat(currentTime.getMinutes()),
        messageType: IM_MessageType.CallStatusUpdateSystemMessage,
        messageId: Guid.NewGuid(),
        postedOn: new Date()
      };
      bridgeComponent.addMessage(callEndMessage);
    }
  }, {
    key: "postForcedLogoutMessage",
    value: function postForcedLogoutMessage() {
      var bridgeComponent = this.refs.bridgeComponent;
      var callEndMessage = {
        message: "Call disconnected because you have logged on another device or browser instance. ",
        messageType: IM_MessageType.CallStatusUpdateSystemMessage,
        messageId: Guid.NewGuid(),
        postedOn: new Date()
      };
      bridgeComponent.addMessage(callEndMessage);
    }
  }, {
    key: "flipCamera",
    value: function flipCamera(event) {
      try {
        this._loggerInstance.logEvent("Flip Camera invoked");

        var self = this;

        if (this._localSelectedCamera == "user") {
          this._localSelectedCamera = "environment";
        } else {
          this._localSelectedCamera = "user";
        }

        var constraints = MediaStreamHelper.getConstraints(true, true, this._localSelectedCamera);
        MediaStreamHelper.getLocalMediaStream(constraints, this.state.localMediaStream).then(function (newStream) {
          try {
            var previousStreams = self.state.previousMediaStreams;
            var modifiedStreams = [].concat(_toConsumableArray(previousStreams), [newStream]);
            self.setState({
              previousMediaStreams: modifiedStreams
            });
            var peer = self.state.peerConnectionObject;
            if (peer == null) console.log('peer object is null.');
            var oldStream = self.state.localMediaStream;
            var oldVideoTrack = oldStream.getVideoTracks()[0];
            var newVideoTrack = newStream.getVideoTracks()[0];

            if (self.state.localOrigMediaStream == null) {
              self.setState({
                localOrigMediaStream: oldStream
              });
            }

            setTimeout(function () {
              peer.replaceTrack(oldVideoTrack, newVideoTrack, self.state.localOrigMediaStream);
            }, 500);
            self.setState({
              localMediaStream: newStream
            });
            self.setState({
              isCallConnected: false
            });
            setTimeout(function () {
              self.setState({
                localMediaStream: newStream,
                isCallConnected: true,
                isWaiting: false,
                isVideoOff: false
              });
              self.state.previousMediaStreams.forEach(function (mediaStream) {
                MediaStreamHelper.setAudioStatus(mediaStream, !self.state.isOnMute);
              });
            }, 100);
          } catch (error) {
            self._loggerInstance.logException(error);
          }
        });
      } catch (error) {
        console.log("navigator.MediaDevices.getUserMedia error: ");

        this._loggerInstance.logException(error);
      } finally {
        if (event && event.preventDefault) {
          event.preventDefault();
        }
      }
    }
  }, {
    key: "toggleMyVideoDisplay",
    value: function toggleMyVideoDisplay(event) {
      var updateStatus = !this.state.isVideoOff;
      MediaStreamHelper.setVideoDisplayStatus(this.state.localMediaStream, updateStatus);
      this.setState({
        isVideoOff: updateStatus
      });

      if (event && event.preventDefault) {
        event.preventDefault();
      }
    }
  }, {
    key: "toggleAudioStatus",
    value: function toggleAudioStatus() {
      var self = this;

      this._loggerInstance.logEvent("Mute button clicked");

      var updatedStatus = !this.state.isOnMute;
      this.setState({
        isOnMute: updatedStatus
      });
      this.state.previousMediaStreams.forEach(function (mediaStream) {
        MediaStreamHelper.setAudioStatus(mediaStream, self.state.isOnMute);
      });

      if (event && event.preventDefault) {
        event.preventDefault();
      }
    }
  }, {
    key: "getCallConnectionStatus",
    value: function getCallConnectionStatus() {
      if (this.state.isConnecting) {
        var message = "Connecting";
        return React.createElement("span", {
          className: "waiting blink_me"
        }, message);
      }

      if (!this.state.isWebSocketConnected) {
        return React.createElement("span", {
          className: "failure blink_me"
        }, "Disconnected");
      }

      if (this.state.isCallConnected) {
        var _message,
            networkMessage = '';

        _message = "Call connected with ".concat(sessionStorage["partnerType"], ".");
        return React.createElement("div", null, React.createElement("div", {
          className: "success"
        }, _message), " ", React.createElement("div", {
          className: "failure blink_me"
        }, " ", networkMessage, " "));
      }

      if (this.state.isWaiting) {
        var _message2 = sessionStorage["partnerType"] + " has not to joined the call yet. Please wait.";

        return React.createElement("span", {
          className: "waiting blink_me"
        }, _message2);
      }

      if (!this.state.isWaiting && !this.state.isCallConnected) {
        var _message3 = "Call Disconnected";
        return React.createElement("span", {
          className: "failure blink_me"
        }, _message3);
      }

      return "";
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement("div", {
        className: "content-body"
      }, React.createElement("div", {
        className: "row"
      }, React.createElement("div", {
        className: "col-md-8"
      }, React.createElement("div", {
        className: "content-body"
      }, React.createElement("div", {
        className: "row callStatusContainer"
      }, React.createElement("div", {
        className: "statusColumn callStatusLabel font-weight-bold"
      }, "Call Status:"), React.createElement("div", {
        className: "statusColumn"
      }, this.getCallConnectionStatus()))))), React.createElement("div", {
        id: "divcallendmessage",
        className: "endcall-PatientMessage",
        style: {
          display: 'none'
        }
      }, "Your call has been disconnect. Please click on call button to re-join."), React.createElement(BridgeComponent, {
        isWaiting: this.state.isWaiting,
        isCallConnected: this.state.isCallConnected,
        ref: "bridgeComponent",
        muteCall: false,
        isVisible: true,
        onSendMessageToPeer: this.onSendMessageToPeer.bind(this),
        remoteMediaStream: this.state.remoteMediaStream,
        localMediaStream: this.state.localMediaStream,
        isOnMute: this.state.isOnMute,
        isVideoOff: this.state.isVideoOff,
        endCall: this.onEndCallByCurrentUser.bind(this),
        style: {
          background: '#FFF'
        }
      }));
    }
  }]);

  return Root;
}(React.Component);